import LoadingButton from '@mui/lab/LoadingButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from '@mui/material';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {userSlice} from 'src/store/user/userSlice';
import {useLayoutEffect} from 'react';
import Iconify from '../iconify';
import {ReactComponent as AlertIcon} from 'src/assets/icons/alert-fill-20.svg'


export default function EndpointErrorModal() {
  const endpointError = useSelector(store => store.user?.endpointError)
  const dispatch = useDispatch()
  const [open, setOpen] = useState()

  useLayoutEffect(() => {
    if (endpointError) {
      setOpen(true)
    }
  }, [endpointError])

  const onClose = () => {
    setOpen(false)
    dispatch(userSlice.actions.setEndpointError(false))
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          maxWidth: 344,
          width: '100%',
        },
      }}
    >
      <DialogTitle>
        <Stack direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack direction='row' alignItems='center' gap={1.5}>
            <AlertIcon />
            <Typography align='left' variant="h5">
              Ошибка
            </Typography>
          </Stack>
          <IconButton size="large" onClick={onClose}>
            <Iconify icon="solar:close-circle-bold" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography>
          Настройки торговой точки не установлены. Обратитесь в поддержку.
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          onClick={onClose}
        >
          Закрыть
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
